import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "Assets/images/logo.png";
import { globalStyles } from "config/pdfStyles";
import { CLASSROOM_PLAN_REPORT_QUESTIONS } from "config/constants";
import RenderAnswer from "./Components/AnswerFields/Index";
import TherapistSignaturePdf from "./Components/TherapistSignature";
import KhanReportLogoPdf from "./Components/KhanReportLogoPdf";
import { dateFormat, userFullName, wrapTextCustom } from "helpers/common";
import moment from 'moment';
import ReportFooter from "./Components/ReportFooter";

// Create styles
const styles = StyleSheet.create({
    header: {
        alignItems: "center",
        justifyContent: "center"
    },
    logo: {
        width: "20%",
    },
    templateHeading: {
        fontSize: "15px",
        marginBottom: "10px",
    },
    templateContainer: {
        flexDirection: "column",
    },
    templateField: {
        paddingVertical: "10px",
    },
    questionHeading: {
        ...globalStyles.fontBold,
        fontSize: "12px",
        marginBottom: "5px",
    },
    goalDetailOuter: {
        backgroundColor: "#fbfbe6",
        padding: "20px",
        marginBottom: "20px",
        borderRadius: "5px"
    },
    goalDetailField: {
        borderRadius: "5px",
        backgroundColor: "#f2f3da",
        padding: "10px 15px"
    },
    tableRow: {
        ...globalStyles.tableRow,
        paddingVertical: "10px"
    },
    guardianDetailRow: {
        paddingVertical: "5px"
    }
});

export const ClassroomConsultationPdfDoc = ({ data }) => {
    const record = data?.record
    const reportHeading = record?.report_heading;
    const reportQuestions = data?.questions;
    const reportAnswers = data?.answers;

    return (
        <Document>
            <Page size="A4" style={globalStyles.page}>

                {/* Report Header */}
                <View style={[globalStyles.section, styles.header]}>
                    <Image
                        style={styles.logo}
                        src={logo}
                    />
                    <Text style={globalStyles.reportHeading}>{reportHeading}</Text>
                </View>
                <View style={globalStyles.section}>
                    <View style={{ backgroundColor: "#f9f9f9", padding: "5px 10px" }}>
                        <View style={globalStyles.table}>

                            <View style={styles.tableRow}>
                                <Text style={globalStyles.tableHead}>Report Date:</Text>
                                <Text style={globalStyles.tableColumn}>{dateFormat(moment())}</Text>

                                <Text style={globalStyles.tableHead}>Clinician Name:</Text>
                                <Text style={globalStyles.tableColumn}>{userFullName(record?.PreflightOwner)}</Text>
                            </View>

                            <View style={styles.tableRow}>
                                <Text style={globalStyles.tableHead}>School Name:</Text>
                                <Text style={globalStyles.tableColumn}>{wrapTextCustom(record?.PreflightSchool?.name)}</Text>

                                <Text style={globalStyles.tableHead}>City/Town:</Text>
                                <Text style={globalStyles.tableColumn}>{wrapTextCustom(record?.PreflightSchool?.location)}</Text>
                            </View>

                            <View style={styles.tableRow}>
                                <Text style={globalStyles.tableHead}>Grade:</Text>
                                <Text style={globalStyles.tableColumn}>{record?.grade || "--"}</Text>

                                <Text style={globalStyles.tableHead}>Teacher:</Text>
                                <Text style={globalStyles.tableColumn}>{userFullName(record?.PreflightTeacher) || "--"}</Text>
                            </View>
                        </View>
                    </View>

                    {/* <View>
                        <Text style={[globalStyles.tableHead, { margin: "10px 0px" }]}>Student #:</Text>
                        <Text style={globalStyles.tableColumn}>{record?.clients?.length || 0}</Text>

                    </View> */}
                </View>

                {/* Questions & Answers */}
                <View style={globalStyles.section}>
                    {reportQuestions?.length > 0 &&
                        reportQuestions?.map((question, index) => {
                            let foundAnswer = reportAnswers?.length && reportAnswers.find(answer => answer.question_id === question.id);
                            if (
                                [
                                    CLASSROOM_PLAN_REPORT_QUESTIONS.counter,
                                ].includes(question.id)
                            ) {
                                return null;
                            }

                            return (
                                <RenderAnswer
                                    key={index}
                                    question={question}
                                    answer={foundAnswer}
                                />
                            );
                        })
                    }
                </View>

                <View style={globalStyles.section}>

                    {/* Therapist Signature */}
                    <View style={globalStyles.reportQuestionOuter} wrap={false}>
                        <TherapistSignaturePdf
                            therapistDetails={{ caseTherapist: record?.PreflightOwner }}
                        />
                    </View>

                    {/* Branding */}
                    <View style={globalStyles.reportQuestionOuter} wrap={false}>
                        <KhanReportLogoPdf />
                    </View>
                </View>

                <ReportFooter
                    data={data}
                />
            </Page>
        </Document>
    )
};
